// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import SchedulerResourceViewModel from '../../../../viewModel/resource/SchedulerResourceViewModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import SchedulerResourceListResultViewModel from '../../../../viewModel/resource/SchedulerResourceListResultViewModel';
import SchedulerResourceListResultDTO from '../../dto/resource/SchedulerResourceListResultDTO';

export default abstract class SchedulerResourceListResultModel extends BaseModel<SchedulerResourceListResultDTO> {
  /**
  */
  get items() { return this.getArrayModels(() => this.dto.items, SchedulerResourceViewModel)!; }
  set items(value) { this.setArrayModels(() => this.dto.items, value); }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
  }
}
